export default "__VITE_ASSET__f75856fd__"